import momentLocalTimezone from 'src/utils/momentLocalTimezone';

export default () => ({
  contractId: '',
  cfdi: '',
  transactionId: '',
  amount: '',
  dueDate: momentLocalTimezone()
});
